import * as R from "react";
import { useLayoutEffect as Ae } from "react";
import * as be from "react-dom";
import { P as At, a as Re } from "./index-wif4gfZf.js";
import { j as X } from "./utils-BdNIfrGQ.js";
import { u as It } from "./index-DLcqcWxM.js";
import { u as Pe } from "./index-0ioNhtNM.js";
import { u as $t } from "./index-CCKe-Mpx.js";
import { u as Oe } from "./index-BGQepRFJ.js";
const Ce = ["top", "right", "bottom", "left"], Z = Math.min, H = Math.max, at = Math.round, ct = Math.floor, z = (t) => ({
  x: t,
  y: t
}), Se = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Ee = {
  start: "end",
  end: "start"
};
function xt(t, e, n) {
  return H(t, Z(e, n));
}
function q(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function U(t) {
  return t.split("-")[0];
}
function tt(t) {
  return t.split("-")[1];
}
function bt(t) {
  return t === "x" ? "y" : "x";
}
function Rt(t) {
  return t === "y" ? "height" : "width";
}
const De = /* @__PURE__ */ new Set(["top", "bottom"]);
function j(t) {
  return De.has(U(t)) ? "y" : "x";
}
function Pt(t) {
  return bt(j(t));
}
function Le(t, e, n) {
  n === void 0 && (n = !1);
  const o = tt(t), r = Pt(t), i = Rt(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = ft(s)), [s, ft(s)];
}
function Te(t) {
  const e = ft(t);
  return [yt(t), e, yt(e)];
}
function yt(t) {
  return t.replace(/start|end/g, (e) => Ee[e]);
}
const kt = ["left", "right"], Nt = ["right", "left"], Me = ["top", "bottom"], $e = ["bottom", "top"];
function ke(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? Nt : kt : e ? kt : Nt;
    case "left":
    case "right":
      return e ? Me : $e;
    default:
      return [];
  }
}
function Ne(t, e, n, o) {
  const r = tt(t);
  let i = ke(U(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(yt)))), i;
}
function ft(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Se[e]);
}
function Fe(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Yt(t) {
  return typeof t != "number" ? Fe(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ut(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Ft(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = j(e), s = Pt(e), c = Rt(s), l = U(e), a = i === "y", f = o.x + o.width / 2 - r.width / 2, u = o.y + o.height / 2 - r.height / 2, p = o[c] / 2 - r[c] / 2;
  let d;
  switch (l) {
    case "top":
      d = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      d = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      d = {
        x: o.x + o.width,
        y: u
      };
      break;
    case "left":
      d = {
        x: o.x - r.width,
        y: u
      };
      break;
    default:
      d = {
        x: o.x,
        y: o.y
      };
  }
  switch (tt(e)) {
    case "start":
      d[s] -= p * (n && a ? -1 : 1);
      break;
    case "end":
      d[s] += p * (n && a ? -1 : 1);
      break;
  }
  return d;
}
const He = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, c = i.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let a = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: f,
    y: u
  } = Ft(a, o, l), p = o, d = {}, m = 0;
  for (let h = 0; h < c.length; h++) {
    const {
      name: w,
      fn: g
    } = c[h], {
      x,
      y: A,
      data: y,
      reset: v
    } = await g({
      x: f,
      y: u,
      initialPlacement: o,
      placement: p,
      strategy: r,
      middlewareData: d,
      rects: a,
      platform: s,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = x ?? f, u = A ?? u, d = {
      ...d,
      [w]: {
        ...d[w],
        ...y
      }
    }, v && m <= 50 && (m++, typeof v == "object" && (v.placement && (p = v.placement), v.rects && (a = v.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : v.rects), {
      x: f,
      y: u
    } = Ft(a, p, l)), h = -1);
  }
  return {
    x: f,
    y: u,
    placement: p,
    strategy: r,
    middlewareData: d
  };
};
async function ot(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: c,
    strategy: l
  } = t, {
    boundary: a = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: u = "floating",
    altBoundary: p = !1,
    padding: d = 0
  } = q(e, t), m = Yt(d), w = c[p ? u === "floating" ? "reference" : "floating" : u], g = ut(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(w))) == null || n ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(c.floating)),
    boundary: a,
    rootBoundary: f,
    strategy: l
  })), x = u === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c.floating)), y = await (i.isElement == null ? void 0 : i.isElement(A)) ? await (i.getScale == null ? void 0 : i.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, v = ut(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: c,
    rect: x,
    offsetParent: A,
    strategy: l
  }) : x);
  return {
    top: (g.top - v.top + m.top) / y.y,
    bottom: (v.bottom - g.bottom + m.bottom) / y.y,
    left: (g.left - v.left + m.left) / y.x,
    right: (v.right - g.right + m.right) / y.x
  };
}
const We = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: c,
      middlewareData: l
    } = e, {
      element: a,
      padding: f = 0
    } = q(t, e) || {};
    if (a == null)
      return {};
    const u = Yt(f), p = {
      x: n,
      y: o
    }, d = Pt(r), m = Rt(d), h = await s.getDimensions(a), w = d === "y", g = w ? "top" : "left", x = w ? "bottom" : "right", A = w ? "clientHeight" : "clientWidth", y = i.reference[m] + i.reference[d] - p[d] - i.floating[m], v = p[d] - i.reference[d], O = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a));
    let P = O ? O[A] : 0;
    (!P || !await (s.isElement == null ? void 0 : s.isElement(O))) && (P = c.floating[A] || i.floating[m]);
    const T = y / 2 - v / 2, N = P / 2 - h[m] / 2 - 1, L = Z(u[g], N), $ = Z(u[x], N), k = L, S = P - h[m] - $, C = P / 2 - h[m] / 2 + T, F = xt(k, C, S), E = !l.arrow && tt(r) != null && C !== F && i.reference[m] / 2 - (C < k ? L : $) - h[m] / 2 < 0, D = E ? C < k ? C - k : C - S : 0;
    return {
      [d]: p[d] + D,
      data: {
        [d]: F,
        centerOffset: C - F - D,
        ...E && {
          alignmentOffset: D
        }
      },
      reset: E
    };
  }
}), _e = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: c,
        platform: l,
        elements: a
      } = e, {
        mainAxis: f = !0,
        crossAxis: u = !0,
        fallbackPlacements: p,
        fallbackStrategy: d = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...w
      } = q(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = U(r), x = j(c), A = U(c) === c, y = await (l.isRTL == null ? void 0 : l.isRTL(a.floating)), v = p || (A || !h ? [ft(c)] : Te(c)), O = m !== "none";
      !p && O && v.push(...Ne(c, h, m, y));
      const P = [c, ...v], T = await ot(e, w), N = [];
      let L = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (f && N.push(T[g]), u) {
        const C = Le(r, s, y);
        N.push(T[C[0]], T[C[1]]);
      }
      if (L = [...L, {
        placement: r,
        overflows: N
      }], !N.every((C) => C <= 0)) {
        var $, k;
        const C = ((($ = i.flip) == null ? void 0 : $.index) || 0) + 1, F = P[C];
        if (F && (!(u === "alignment" ? x !== j(F) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        L.every((b) => b.overflows[0] > 0 && j(b.placement) === x)))
          return {
            data: {
              index: C,
              overflows: L
            },
            reset: {
              placement: F
            }
          };
        let E = (k = L.filter((D) => D.overflows[0] <= 0).sort((D, b) => D.overflows[1] - b.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!E)
          switch (d) {
            case "bestFit": {
              var S;
              const D = (S = L.filter((b) => {
                if (O) {
                  const M = j(b.placement);
                  return M === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  M === "y";
                }
                return !0;
              }).map((b) => [b.placement, b.overflows.filter((M) => M > 0).reduce((M, V) => M + V, 0)]).sort((b, M) => b[1] - M[1])[0]) == null ? void 0 : S[0];
              D && (E = D);
              break;
            }
            case "initialPlacement":
              E = c;
              break;
          }
        if (r !== E)
          return {
            reset: {
              placement: E
            }
          };
      }
      return {};
    }
  };
};
function Ht(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Wt(t) {
  return Ce.some((e) => t[e] >= 0);
}
const Be = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n
      } = e, {
        strategy: o = "referenceHidden",
        ...r
      } = q(t, e);
      switch (o) {
        case "referenceHidden": {
          const i = await ot(e, {
            ...r,
            elementContext: "reference"
          }), s = Ht(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Wt(s)
            }
          };
        }
        case "escaped": {
          const i = await ot(e, {
            ...r,
            altBoundary: !0
          }), s = Ht(i, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Wt(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Xt = /* @__PURE__ */ new Set(["left", "top"]);
async function Ve(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = U(n), c = tt(n), l = j(n) === "y", a = Xt.has(s) ? -1 : 1, f = i && l ? -1 : 1, u = q(e, t);
  let {
    mainAxis: p,
    crossAxis: d,
    alignmentAxis: m
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return c && typeof m == "number" && (d = c === "end" ? m * -1 : m), l ? {
    x: d * f,
    y: p * a
  } : {
    x: p * a,
    y: d * f
  };
}
const je = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: c
      } = e, l = await Ve(e, t);
      return s === ((n = c.offset) == null ? void 0 : n.placement) && (o = c.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
}, ze = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r
      } = e, {
        mainAxis: i = !0,
        crossAxis: s = !1,
        limiter: c = {
          fn: (w) => {
            let {
              x: g,
              y: x
            } = w;
            return {
              x: g,
              y: x
            };
          }
        },
        ...l
      } = q(t, e), a = {
        x: n,
        y: o
      }, f = await ot(e, l), u = j(U(r)), p = bt(u);
      let d = a[p], m = a[u];
      if (i) {
        const w = p === "y" ? "top" : "left", g = p === "y" ? "bottom" : "right", x = d + f[w], A = d - f[g];
        d = xt(x, d, A);
      }
      if (s) {
        const w = u === "y" ? "top" : "left", g = u === "y" ? "bottom" : "right", x = m + f[w], A = m - f[g];
        m = xt(x, m, A);
      }
      const h = c.fn({
        ...e,
        [p]: d,
        [u]: m
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - o,
          enabled: {
            [p]: i,
            [u]: s
          }
        }
      };
    }
  };
}, Ie = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: s
      } = e, {
        offset: c = 0,
        mainAxis: l = !0,
        crossAxis: a = !0
      } = q(t, e), f = {
        x: n,
        y: o
      }, u = j(r), p = bt(u);
      let d = f[p], m = f[u];
      const h = q(c, e), w = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (l) {
        const A = p === "y" ? "height" : "width", y = i.reference[p] - i.floating[A] + w.mainAxis, v = i.reference[p] + i.reference[A] - w.mainAxis;
        d < y ? d = y : d > v && (d = v);
      }
      if (a) {
        var g, x;
        const A = p === "y" ? "width" : "height", y = Xt.has(U(r)), v = i.reference[u] - i.floating[A] + (y && ((g = s.offset) == null ? void 0 : g[u]) || 0) + (y ? 0 : w.crossAxis), O = i.reference[u] + i.reference[A] + (y ? 0 : ((x = s.offset) == null ? void 0 : x[u]) || 0) - (y ? w.crossAxis : 0);
        m < v ? m = v : m > O && (m = O);
      }
      return {
        [p]: d,
        [u]: m
      };
    }
  };
}, Ye = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: i,
        platform: s,
        elements: c
      } = e, {
        apply: l = () => {
        },
        ...a
      } = q(t, e), f = await ot(e, a), u = U(r), p = tt(r), d = j(r) === "y", {
        width: m,
        height: h
      } = i.floating;
      let w, g;
      u === "top" || u === "bottom" ? (w = u, g = p === (await (s.isRTL == null ? void 0 : s.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (g = u, w = p === "end" ? "top" : "bottom");
      const x = h - f.top - f.bottom, A = m - f.left - f.right, y = Z(h - f[w], x), v = Z(m - f[g], A), O = !e.middlewareData.shift;
      let P = y, T = v;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (T = A), (o = e.middlewareData.shift) != null && o.enabled.y && (P = x), O && !p) {
        const L = H(f.left, 0), $ = H(f.right, 0), k = H(f.top, 0), S = H(f.bottom, 0);
        d ? T = m - 2 * (L !== 0 || $ !== 0 ? L + $ : H(f.left, f.right)) : P = h - 2 * (k !== 0 || S !== 0 ? k + S : H(f.top, f.bottom));
      }
      await l({
        ...e,
        availableWidth: T,
        availableHeight: P
      });
      const N = await s.getDimensions(c.floating);
      return m !== N.width || h !== N.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function mt() {
  return typeof window < "u";
}
function et(t) {
  return qt(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function W(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Y(t) {
  var e;
  return (e = (qt(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function qt(t) {
  return mt() ? t instanceof Node || t instanceof W(t).Node : !1;
}
function _(t) {
  return mt() ? t instanceof Element || t instanceof W(t).Element : !1;
}
function I(t) {
  return mt() ? t instanceof HTMLElement || t instanceof W(t).HTMLElement : !1;
}
function _t(t) {
  return !mt() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof W(t).ShadowRoot;
}
const Xe = /* @__PURE__ */ new Set(["inline", "contents"]);
function it(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = B(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !Xe.has(r);
}
const qe = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Ue(t) {
  return qe.has(et(t));
}
const Ze = [":popover-open", ":modal"];
function pt(t) {
  return Ze.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const Ke = ["transform", "translate", "scale", "rotate", "perspective"], Ge = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Je = ["paint", "layout", "strict", "content"];
function Ot(t) {
  const e = Ct(), n = _(t) ? B(t) : t;
  return Ke.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || Ge.some((o) => (n.willChange || "").includes(o)) || Je.some((o) => (n.contain || "").includes(o));
}
function Qe(t) {
  let e = K(t);
  for (; I(e) && !Q(e); ) {
    if (Ot(e))
      return e;
    if (pt(e))
      return null;
    e = K(e);
  }
  return null;
}
function Ct() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const tn = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Q(t) {
  return tn.has(et(t));
}
function B(t) {
  return W(t).getComputedStyle(t);
}
function ht(t) {
  return _(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function K(t) {
  if (et(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    _t(t) && t.host || // Fallback.
    Y(t)
  );
  return _t(e) ? e.host : e;
}
function Ut(t) {
  const e = K(t);
  return Q(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : I(e) && it(e) ? e : Ut(e);
}
function rt(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = Ut(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = W(r);
  if (i) {
    const c = vt(s);
    return e.concat(s, s.visualViewport || [], it(r) ? r : [], c && n ? rt(c) : []);
  }
  return e.concat(r, rt(r, [], n));
}
function vt(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function Zt(t) {
  const e = B(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = I(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, c = at(n) !== i || at(o) !== s;
  return c && (n = i, o = s), {
    width: n,
    height: o,
    $: c
  };
}
function St(t) {
  return _(t) ? t : t.contextElement;
}
function J(t) {
  const e = St(t);
  if (!I(e))
    return z(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = Zt(e);
  let s = (i ? at(n.width) : n.width) / o, c = (i ? at(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!c || !Number.isFinite(c)) && (c = 1), {
    x: s,
    y: c
  };
}
const en = /* @__PURE__ */ z(0);
function Kt(t) {
  const e = W(t);
  return !Ct() || !e.visualViewport ? en : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function nn(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== W(t) ? !1 : e;
}
function G(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = St(t);
  let s = z(1);
  e && (o ? _(o) && (s = J(o)) : s = J(t));
  const c = nn(i, n, o) ? Kt(i) : z(0);
  let l = (r.left + c.x) / s.x, a = (r.top + c.y) / s.y, f = r.width / s.x, u = r.height / s.y;
  if (i) {
    const p = W(i), d = o && _(o) ? W(o) : o;
    let m = p, h = vt(m);
    for (; h && o && d !== m; ) {
      const w = J(h), g = h.getBoundingClientRect(), x = B(h), A = g.left + (h.clientLeft + parseFloat(x.paddingLeft)) * w.x, y = g.top + (h.clientTop + parseFloat(x.paddingTop)) * w.y;
      l *= w.x, a *= w.y, f *= w.x, u *= w.y, l += A, a += y, m = W(h), h = vt(m);
    }
  }
  return ut({
    width: f,
    height: u,
    x: l,
    y: a
  });
}
function Et(t, e) {
  const n = ht(t).scrollLeft;
  return e ? e.left + n : G(Y(t)).left + n;
}
function Gt(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), r = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Et(t, o)
  )), i = o.top + e.scrollTop;
  return {
    x: r,
    y: i
  };
}
function on(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = Y(o), c = e ? pt(e.floating) : !1;
  if (o === s || c && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = z(1);
  const f = z(0), u = I(o);
  if ((u || !u && !i) && ((et(o) !== "body" || it(s)) && (l = ht(o)), I(o))) {
    const d = G(o);
    a = J(o), f.x = d.x + o.clientLeft, f.y = d.y + o.clientTop;
  }
  const p = s && !u && !i ? Gt(s, l, !0) : z(0);
  return {
    width: n.width * a.x,
    height: n.height * a.y,
    x: n.x * a.x - l.scrollLeft * a.x + f.x + p.x,
    y: n.y * a.y - l.scrollTop * a.y + f.y + p.y
  };
}
function rn(t) {
  return Array.from(t.getClientRects());
}
function sn(t) {
  const e = Y(t), n = ht(t), o = t.ownerDocument.body, r = H(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = H(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + Et(t);
  const c = -n.scrollTop;
  return B(o).direction === "rtl" && (s += H(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: c
  };
}
function cn(t, e) {
  const n = W(t), o = Y(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, c = 0, l = 0;
  if (r) {
    i = r.width, s = r.height;
    const a = Ct();
    (!a || a && e === "fixed") && (c = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: c,
    y: l
  };
}
const ln = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function an(t, e) {
  const n = G(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = I(t) ? J(t) : z(1), s = t.clientWidth * i.x, c = t.clientHeight * i.y, l = r * i.x, a = o * i.y;
  return {
    width: s,
    height: c,
    x: l,
    y: a
  };
}
function Bt(t, e, n) {
  let o;
  if (e === "viewport")
    o = cn(t, n);
  else if (e === "document")
    o = sn(Y(t));
  else if (_(e))
    o = an(e, n);
  else {
    const r = Kt(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return ut(o);
}
function Jt(t, e) {
  const n = K(t);
  return n === e || !_(n) || Q(n) ? !1 : B(n).position === "fixed" || Jt(n, e);
}
function fn(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = rt(t, [], !1).filter((c) => _(c) && et(c) !== "body"), r = null;
  const i = B(t).position === "fixed";
  let s = i ? K(t) : t;
  for (; _(s) && !Q(s); ) {
    const c = B(s), l = Ot(s);
    !l && c.position === "fixed" && (r = null), (i ? !l && !r : !l && c.position === "static" && !!r && ln.has(r.position) || it(s) && !l && Jt(t, s)) ? o = o.filter((f) => f !== s) : r = c, s = K(s);
  }
  return e.set(t, o), o;
}
function un(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? pt(e) ? [] : fn(e, this._c) : [].concat(n), o], c = s[0], l = s.reduce((a, f) => {
    const u = Bt(e, f, r);
    return a.top = H(u.top, a.top), a.right = Z(u.right, a.right), a.bottom = Z(u.bottom, a.bottom), a.left = H(u.left, a.left), a;
  }, Bt(e, c, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function dn(t) {
  const {
    width: e,
    height: n
  } = Zt(t);
  return {
    width: e,
    height: n
  };
}
function mn(t, e, n) {
  const o = I(e), r = Y(e), i = n === "fixed", s = G(t, !0, i, e);
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = z(0);
  function a() {
    l.x = Et(r);
  }
  if (o || !o && !i)
    if ((et(e) !== "body" || it(r)) && (c = ht(e)), o) {
      const d = G(e, !0, i, e);
      l.x = d.x + e.clientLeft, l.y = d.y + e.clientTop;
    } else r && a();
  i && !o && r && a();
  const f = r && !o && !i ? Gt(r, c) : z(0), u = s.left + c.scrollLeft - l.x - f.x, p = s.top + c.scrollTop - l.y - f.y;
  return {
    x: u,
    y: p,
    width: s.width,
    height: s.height
  };
}
function gt(t) {
  return B(t).position === "static";
}
function Vt(t, e) {
  if (!I(t) || B(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return Y(t) === n && (n = n.ownerDocument.body), n;
}
function Qt(t, e) {
  const n = W(t);
  if (pt(t))
    return n;
  if (!I(t)) {
    let r = K(t);
    for (; r && !Q(r); ) {
      if (_(r) && !gt(r))
        return r;
      r = K(r);
    }
    return n;
  }
  let o = Vt(t, e);
  for (; o && Ue(o) && gt(o); )
    o = Vt(o, e);
  return o && Q(o) && gt(o) && !Ot(o) ? n : o || Qe(t) || n;
}
const pn = async function(t) {
  const e = this.getOffsetParent || Qt, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: mn(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function hn(t) {
  return B(t).direction === "rtl";
}
const gn = {
  convertOffsetParentRelativeRectToViewportRelativeRect: on,
  getDocumentElement: Y,
  getClippingRect: un,
  getOffsetParent: Qt,
  getElementRects: pn,
  getClientRects: rn,
  getDimensions: dn,
  getScale: J,
  isElement: _,
  isRTL: hn
};
function te(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function wn(t, e) {
  let n = null, o;
  const r = Y(t);
  function i() {
    var c;
    clearTimeout(o), (c = n) == null || c.disconnect(), n = null;
  }
  function s(c, l) {
    c === void 0 && (c = !1), l === void 0 && (l = 1), i();
    const a = t.getBoundingClientRect(), {
      left: f,
      top: u,
      width: p,
      height: d
    } = a;
    if (c || e(), !p || !d)
      return;
    const m = ct(u), h = ct(r.clientWidth - (f + p)), w = ct(r.clientHeight - (u + d)), g = ct(f), A = {
      rootMargin: -m + "px " + -h + "px " + -w + "px " + -g + "px",
      threshold: H(0, Z(1, l)) || 1
    };
    let y = !0;
    function v(O) {
      const P = O[0].intersectionRatio;
      if (P !== l) {
        if (!y)
          return s();
        P ? s(!1, P) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      P === 1 && !te(a, t.getBoundingClientRect()) && s(), y = !1;
    }
    try {
      n = new IntersectionObserver(v, {
        ...A,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(v, A);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function xn(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: c = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, a = St(t), f = r || i ? [...a ? rt(a) : [], ...rt(e)] : [];
  f.forEach((g) => {
    r && g.addEventListener("scroll", n, {
      passive: !0
    }), i && g.addEventListener("resize", n);
  });
  const u = a && c ? wn(a, n) : null;
  let p = -1, d = null;
  s && (d = new ResizeObserver((g) => {
    let [x] = g;
    x && x.target === a && d && (d.unobserve(e), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var A;
      (A = d) == null || A.observe(e);
    })), n();
  }), a && !l && d.observe(a), d.observe(e));
  let m, h = l ? G(t) : null;
  l && w();
  function w() {
    const g = G(t);
    h && !te(h, g) && n(), h = g, m = requestAnimationFrame(w);
  }
  return n(), () => {
    var g;
    f.forEach((x) => {
      r && x.removeEventListener("scroll", n), i && x.removeEventListener("resize", n);
    }), u?.(), (g = d) == null || g.disconnect(), d = null, l && cancelAnimationFrame(m);
  };
}
const yn = je, vn = ze, An = _e, bn = Ye, Rn = Be, jt = We, Pn = Ie, On = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: gn,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return He(t, e, {
    ...r,
    platform: i
  });
};
var Cn = typeof document < "u", Sn = function() {
}, lt = Cn ? Ae : Sn;
function dt(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!dt(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !dt(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function ee(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function zt(t, e) {
  const n = ee(t);
  return Math.round(e * n) / n;
}
function wt(t) {
  const e = R.useRef(t);
  return lt(() => {
    e.current = t;
  }), e;
}
function En(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: c = !0,
    whileElementsMounted: l,
    open: a
  } = t, [f, u] = R.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [p, d] = R.useState(o);
  dt(p, o) || d(o);
  const [m, h] = R.useState(null), [w, g] = R.useState(null), x = R.useCallback((b) => {
    b !== O.current && (O.current = b, h(b));
  }, []), A = R.useCallback((b) => {
    b !== P.current && (P.current = b, g(b));
  }, []), y = i || m, v = s || w, O = R.useRef(null), P = R.useRef(null), T = R.useRef(f), N = l != null, L = wt(l), $ = wt(r), k = wt(a), S = R.useCallback(() => {
    if (!O.current || !P.current)
      return;
    const b = {
      placement: e,
      strategy: n,
      middleware: p
    };
    $.current && (b.platform = $.current), On(O.current, P.current, b).then((M) => {
      const V = {
        ...M,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      C.current && !dt(T.current, V) && (T.current = V, be.flushSync(() => {
        u(V);
      }));
    });
  }, [p, e, n, $, k]);
  lt(() => {
    a === !1 && T.current.isPositioned && (T.current.isPositioned = !1, u((b) => ({
      ...b,
      isPositioned: !1
    })));
  }, [a]);
  const C = R.useRef(!1);
  lt(() => (C.current = !0, () => {
    C.current = !1;
  }), []), lt(() => {
    if (y && (O.current = y), v && (P.current = v), y && v) {
      if (L.current)
        return L.current(y, v, S);
      S();
    }
  }, [y, v, S, L, N]);
  const F = R.useMemo(() => ({
    reference: O,
    floating: P,
    setReference: x,
    setFloating: A
  }), [x, A]), E = R.useMemo(() => ({
    reference: y,
    floating: v
  }), [y, v]), D = R.useMemo(() => {
    const b = {
      position: n,
      left: 0,
      top: 0
    };
    if (!E.floating)
      return b;
    const M = zt(E.floating, f.x), V = zt(E.floating, f.y);
    return c ? {
      ...b,
      transform: "translate(" + M + "px, " + V + "px)",
      ...ee(E.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: M,
      top: V
    };
  }, [n, c, E.floating, f.x, f.y]);
  return R.useMemo(() => ({
    ...f,
    update: S,
    refs: F,
    elements: E,
    floatingStyles: D
  }), [f, S, F, E, D]);
}
const Dn = (t) => {
  function e(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: t,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof t == "function" ? t(n) : t;
      return o && e(o) ? o.current != null ? jt({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? jt({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Ln = (t, e) => ({
  ...yn(t),
  options: [t, e]
}), Tn = (t, e) => ({
  ...vn(t),
  options: [t, e]
}), Mn = (t, e) => ({
  ...Pn(t),
  options: [t, e]
}), $n = (t, e) => ({
  ...An(t),
  options: [t, e]
}), kn = (t, e) => ({
  ...bn(t),
  options: [t, e]
}), Nn = (t, e) => ({
  ...Rn(t),
  options: [t, e]
}), Fn = (t, e) => ({
  ...Dn(t),
  options: [t, e]
});
var Hn = "Arrow", ne = R.forwardRef((t, e) => {
  const { children: n, width: o = 10, height: r = 5, ...i } = t;
  return /* @__PURE__ */ X.jsx(
    At.svg,
    {
      ...i,
      ref: e,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ X.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
ne.displayName = Hn;
var Wn = ne, Dt = "Popper", [oe, Jn] = Re(Dt), [_n, re] = oe(Dt), ie = (t) => {
  const { __scopePopper: e, children: n } = t, [o, r] = R.useState(null);
  return /* @__PURE__ */ X.jsx(_n, { scope: e, anchor: o, onAnchorChange: r, children: n });
};
ie.displayName = Dt;
var se = "PopperAnchor", ce = R.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: o, ...r } = t, i = re(se, n), s = R.useRef(null), c = It(e, s), l = R.useRef(null);
    return R.useEffect(() => {
      const a = l.current;
      l.current = o?.current || s.current, a !== l.current && i.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ X.jsx(At.div, { ...r, ref: c });
  }
);
ce.displayName = se;
var Lt = "PopperContent", [Bn, Vn] = oe(Lt), le = R.forwardRef(
  (t, e) => {
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: i = "center",
      alignOffset: s = 0,
      arrowPadding: c = 0,
      avoidCollisions: l = !0,
      collisionBoundary: a = [],
      collisionPadding: f = 0,
      sticky: u = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: d = "optimized",
      onPlaced: m,
      ...h
    } = t, w = re(Lt, n), [g, x] = R.useState(null), A = It(e, (nt) => x(nt)), [y, v] = R.useState(null), O = Oe(y), P = O?.width ?? 0, T = O?.height ?? 0, N = o + (i !== "center" ? "-" + i : ""), L = typeof f == "number" ? f : { top: 0, right: 0, bottom: 0, left: 0, ...f }, $ = Array.isArray(a) ? a : [a], k = $.length > 0, S = {
      padding: L,
      boundary: $.filter(zn),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: k
    }, { refs: C, floatingStyles: F, placement: E, isPositioned: D, middlewareData: b } = En({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: N,
      whileElementsMounted: (...nt) => xn(...nt, {
        animationFrame: d === "always"
      }),
      elements: {
        reference: w.anchor
      },
      middleware: [
        Ln({ mainAxis: r + T, alignmentAxis: s }),
        l && Tn({
          mainAxis: !0,
          crossAxis: !1,
          limiter: u === "partial" ? Mn() : void 0,
          ...S
        }),
        l && $n({ ...S }),
        kn({
          ...S,
          apply: ({ elements: nt, rects: Mt, availableWidth: we, availableHeight: xe }) => {
            const { width: ye, height: ve } = Mt.reference, st = nt.floating.style;
            st.setProperty("--radix-popper-available-width", `${we}px`), st.setProperty("--radix-popper-available-height", `${xe}px`), st.setProperty("--radix-popper-anchor-width", `${ye}px`), st.setProperty("--radix-popper-anchor-height", `${ve}px`);
          }
        }),
        y && Fn({ element: y, padding: c }),
        In({ arrowWidth: P, arrowHeight: T }),
        p && Nn({ strategy: "referenceHidden", ...S })
      ]
    }), [M, V] = ue(E), Tt = Pe(m);
    $t(() => {
      D && Tt?.();
    }, [D, Tt]);
    const de = b.arrow?.x, me = b.arrow?.y, pe = b.arrow?.centerOffset !== 0, [he, ge] = R.useState();
    return $t(() => {
      g && ge(window.getComputedStyle(g).zIndex);
    }, [g]), /* @__PURE__ */ X.jsx(
      "div",
      {
        ref: C.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...F,
          transform: D ? F.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: he,
          "--radix-popper-transform-origin": [
            b.transformOrigin?.x,
            b.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...b.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ X.jsx(
          Bn,
          {
            scope: n,
            placedSide: M,
            onArrowChange: v,
            arrowX: de,
            arrowY: me,
            shouldHideArrow: pe,
            children: /* @__PURE__ */ X.jsx(
              At.div,
              {
                "data-side": M,
                "data-align": V,
                ...h,
                ref: A,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: D ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
le.displayName = Lt;
var ae = "PopperArrow", jn = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, fe = R.forwardRef(function(e, n) {
  const { __scopePopper: o, ...r } = e, i = Vn(ae, o), s = jn[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ X.jsx(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ X.jsx(
          Wn,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
fe.displayName = ae;
function zn(t) {
  return t !== null;
}
var In = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    const { placement: n, rects: o, middlewareData: r } = e, s = r.arrow?.centerOffset !== 0, c = s ? 0 : t.arrowWidth, l = s ? 0 : t.arrowHeight, [a, f] = ue(n), u = { start: "0%", center: "50%", end: "100%" }[f], p = (r.arrow?.x ?? 0) + c / 2, d = (r.arrow?.y ?? 0) + l / 2;
    let m = "", h = "";
    return a === "bottom" ? (m = s ? u : `${p}px`, h = `${-l}px`) : a === "top" ? (m = s ? u : `${p}px`, h = `${o.floating.height + l}px`) : a === "right" ? (m = `${-l}px`, h = s ? u : `${d}px`) : a === "left" && (m = `${o.floating.width + l}px`, h = s ? u : `${d}px`), { data: { x: m, y: h } };
  }
});
function ue(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Qn = ie, to = ce, eo = le, no = fe;
export {
  to as A,
  eo as C,
  Qn as R,
  no as a,
  Jn as c
};
